export type { ConsumablesMasterProps } from './consumables-master';
export * from './consumables-master.routes';

export { default as ConsumablesMaster, default } from './consumables-master';
